import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NZ_I18N, en_US } from "ng-zorro-antd/i18n";
import { NzBreadCrumbModule } from "ng-zorro-antd/breadcrumb";
import { NZ_CONFIG, NzConfig } from "ng-zorro-antd/core/config";

import {
  registerLocaleData,
  PathLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import en from "@angular/common/locales/en";

import { AppRoutingModule } from "./app_routing.module";
import { TemplateModule } from "./shared/template/template.module";
import { SharedModule } from "./shared/shared.module";

import { AppComponent } from "./app.component";
import { CommonLayoutComponent } from "./layouts/common-layout/common-layout.component";

import { ThemeConstantService } from "./shared/services/theme_constant.service";
import { globalData } from "./shared/services/globaldata";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NzNotificationModule } from "ng-zorro-antd/notification";
import { NzModalModule } from 'ng-zorro-antd/modal';
import { AuthInterceptor } from "./shared/interceptors/auth.interceptor";
import { RUNTIME_ENV } from "./shared/tokens/runtime_env.token";
import { TableEmptyStateComponent } from "./shared/components/table_empty_state/table_empty_state.component";
import { EvidenceRequirementsHostComponent } from "./shared/components/evidence_requirements_host/evidence_requirements_host.component";

// Read whatever /assets/env.js set (falls back to empty object locally)
const runtimeEnv = (typeof window !== 'undefined' && window.__env)
  ? window.__env
  : {};

const ngZorroConfig: NzConfig = {
    empty: {
        nzDefaultEmptyContent: TableEmptyStateComponent
    }
};

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent, CommonLayoutComponent, EvidenceRequirementsHostComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NzBreadCrumbModule,
    TemplateModule,
    SharedModule,
    HttpClientModule,
    NzNotificationModule,
    NzModalModule
  ],
  providers: [
    {
      provide: NZ_I18N,
      useValue: en_US,
    },
    { provide: RUNTIME_ENV, useValue: runtimeEnv },
    { provide: globalData, useClass: globalData },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: NZ_CONFIG,
      useValue: ngZorroConfig,
    },
    ThemeConstantService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
